import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a431319"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "ion-margin-vertical" }
const _hoisted_4 = { slot: "start" }
const _hoisted_5 = { class: "responsive-table" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "ion-text-center" }
const _hoisted_10 = { class: "flex-container" }
const _hoisted_11 = { class: "flex-container" }
const _hoisted_12 = { class: "ion-text-center" }
const _hoisted_13 = { class: "flex-container" }
const _hoisted_14 = { style: {"min-width":"60px"} }
const _hoisted_15 = {
  key: 0,
  class: "new-row"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "input-cell" }
const _hoisted_19 = { class: "ion-text-center input-cell" }
const _hoisted_20 = { class: "input-cell" }
const _hoisted_21 = { class: "flex-container" }
const _hoisted_22 = { class: "input-cell" }
const _hoisted_23 = { class: "flex-container" }
const _hoisted_24 = { class: "ion-text-center" }
const _hoisted_25 = { class: "flex-container" }
const _hoisted_26 = { style: {"min-width":"60px"} }
const _hoisted_27 = {
  slot: "start",
  class: "ion-hide-md-down"
}
const _hoisted_28 = {
  slot: "end",
  class: "toolbar-padding"
}
const _hoisted_29 = { class: "responsive-table" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_31 = { class: "input-cell" }
const _hoisted_32 = { class: "ion-text-center input-cell" }
const _hoisted_33 = { class: "input-cell" }
const _hoisted_34 = { class: "flex-container" }
const _hoisted_35 = { class: "input-cell" }
const _hoisted_36 = { class: "flex-container" }
const _hoisted_37 = { class: "ion-text-center" }
const _hoisted_38 = { class: "flex-container" }
const _hoisted_39 = { style: {"min-width":"60px"} }
const _hoisted_40 = {
  key: 0,
  class: "new-row"
}
const _hoisted_41 = { class: "input-cell" }
const _hoisted_42 = { class: "ion-text-center input-cell" }
const _hoisted_43 = { class: "input-cell" }
const _hoisted_44 = { class: "flex-container" }
const _hoisted_45 = { class: "input-cell" }
const _hoisted_46 = { class: "flex-container" }
const _hoisted_47 = { class: "ion-text-center" }
const _hoisted_48 = { class: "flex-container" }
const _hoisted_49 = { class: "ion-margin-vertical" }
const _hoisted_50 = { class: "ion-margin-vertical" }
const _hoisted_51 = { class: "summary-card" }
const _hoisted_52 = { class: "responsive-table" }
const _hoisted_53 = { class: "data" }
const _hoisted_54 = { class: "data" }
const _hoisted_55 = { class: "data" }
const _hoisted_56 = { class: "data" }
const _hoisted_57 = { class: "data" }
const _hoisted_58 = { class: "data" }
const _hoisted_59 = { class: "data" }
const _hoisted_60 = { class: "data" }
const _hoisted_61 = { class: "ion-text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_import_data_modal = _resolveComponent("import-data-modal")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_auto_fill_select = _resolveComponent("auto-fill-select")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_alert = _resolveComponent("ion-alert")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.dataLoaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_ion_spinner),
          _createVNode(_component_ion_text, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('LoadingData')), 1)
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_import_data_modal, {
            crop: _ctx.cropId,
            step: "treatment",
            onImportData: _ctx.handleImportData
          }, null, 8, ["crop", "onImportData"]),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category, index_category) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index_category,
                class: "ion-margin-vertical"
              }, [
                _createVNode(_component_ion_toolbar, { class: "ion-margin-vertical" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_ion_text, { class: "ion-padding-horizontal" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(category.name), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]),
                  _: 2
                }, 1024),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("table", null, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('Product')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('ProductType')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('AreaTreated')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('DoseProSpreadHa')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('Cost')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('TotalQuantity')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('CostProHaTotalArea')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('IFTProHaTotalArea')), 1),
                      _hoisted_6
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTreatments(category.id), (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          (category.name == 'Molluscicide')
                            ? (_openBlock(), _createElementBlock("td", _hoisted_7, [
                                _createVNode(_component_auto_fill_select, {
                                  options: _ctx.getProductsByCategory('Molluscicide'),
                                  searchField: "product_name",
                                  label: _ctx.translations[_ctx.currentLanguage].Product,
                                  placeholder: _ctx.translations[_ctx.currentLanguage].Search,
                                  selected: item.product_name,
                                  "onUpdate:modelValue": option => _ctx.handleSelected(option, item, 'product', true)
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" >")
                                  ]),
                                  _: 2
                                }, 1032, ["options", "label", "placeholder", "selected", "onUpdate:modelValue"])
                              ]))
                            : (_openBlock(), _createElementBlock("td", _hoisted_8, [
                                _createVNode(_component_auto_fill_select, {
                                  options: _ctx.products,
                                  searchField: "product_name",
                                  label: _ctx.translations[_ctx.currentLanguage].Product,
                                  placeholder: _ctx.translations[_ctx.currentLanguage].Search,
                                  selected: item.product_name,
                                  "onUpdate:modelValue": option => _ctx.handleSelected(option, item, 'product', true)
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" >")
                                  ]),
                                  _: 2
                                }, 1032, ["options", "label", "placeholder", "selected", "onUpdate:modelValue"])
                              ])),
                          _createElementVNode("td", null, [
                            _createVNode(_component_ion_input, {
                              readonly: "true",
                              modelValue: item.product_type_name,
                              "onUpdate:modelValue": ($event: any) => ((item.product_type_name) = $event),
                              class: "ion-text-center readonly"
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _createElementVNode("td", _hoisted_9, [
                            _createVNode(_component_ion_input, {
                              type: "number",
                              min: "0",
                              max: "100",
                              modelValue: item.area_treated,
                              "onUpdate:modelValue": ($event: any) => ((item.area_treated) = $event),
                              modelModifiers: { number: true },
                              onIonInput: ($event: any) => (_ctx.calculateDoseProHa(item)),
                              class: "ion-text-center"
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onIonInput"])
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_10, [
                              _createVNode(_component_ion_input, {
                                type: "number",
                                min: "0",
                                step: "any",
                                modelValue: item.dose_pro_spread_ha,
                                "onUpdate:modelValue": ($event: any) => ((item.dose_pro_spread_ha) = $event),
                                onIonInput: ($event: any) => (_ctx.calculateDoseProHa(item)),
                                class: "ion-text-center"
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onIonInput"]),
                              _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.unit.replace('/ha', '').toUpperCase()) + " " + _toDisplayString(_ctx.$t('UnitProHa')), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_11, [
                              _createVNode(_component_ion_input, {
                                type: "number",
                                min: "0",
                                modelValue: item.cost,
                                "onUpdate:modelValue": ($event: any) => ((item.cost) = $event),
                                modelModifiers: { number: true },
                                onIonInput: ($event: any) => (_ctx.handleDebouncedupdate($event, item)),
                                class: "ion-text-center"
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onIonInput"]),
                              _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('UnitEuro')) + " / " + _toDisplayString(item.unit.replace('/ha', '').toUpperCase()), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_12, [
                            _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.total_quantity) + " " + _toDisplayString(item.unit.replace('/ha', '').toUpperCase()), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_13, [
                              _createVNode(_component_ion_input, {
                                type: "number",
                                min: "0",
                                modelValue: item.cost_pro_ha,
                                "onUpdate:modelValue": ($event: any) => ((item.cost_pro_ha) = $event),
                                modelModifiers: { number: true },
                                readonly: "true",
                                class: "ion-text-center readonly"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                              _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('UnitEuroProHa')), 1)
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_14, [
                            _createVNode(_component_ion_input, {
                              type: "number",
                              min: "0",
                              modelValue: item.ift,
                              "onUpdate:modelValue": ($event: any) => ((item.ift) = $event),
                              modelModifiers: { number: true },
                              readonly: "true",
                              class: "ion-text-center readonly"
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(_component_ion_button, {
                              onClick: ($event: any) => (_ctx.deleteTreatmentItem(item.id)),
                              color: "danger"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, { icon: _ctx.trashOutline }, null, 8, ["icon"])
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ])
                        ]))
                      }), 128)),
                      (_ctx.getNewItemByCategory(category.id))
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                            (category.name == 'Molluscicide')
                              ? (_openBlock(), _createElementBlock("td", _hoisted_16, [
                                  _createVNode(_component_auto_fill_select, {
                                    options: _ctx.getProductsByCategory('Molluscicide'),
                                    searchField: "product_name",
                                    label: _ctx.translations[_ctx.currentLanguage].Product,
                                    placeholder: _ctx.translations[_ctx.currentLanguage].Search,
                                    ref_for: true,
                                    ref: el => { if (el) _ctx.productRefs[category.id] = el },
                                    "onUpdate:modelValue": option => _ctx.handleSelected(option, _ctx.getNewItemByCategory(category.id), 'product', false)
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" >")
                                    ]),
                                    _: 2
                                  }, 1032, ["options", "label", "placeholder", "onUpdate:modelValue"])
                                ]))
                              : (_openBlock(), _createElementBlock("td", _hoisted_17, [
                                  _createVNode(_component_auto_fill_select, {
                                    options: _ctx.products,
                                    searchField: "product_name",
                                    label: _ctx.translations[_ctx.currentLanguage].Product,
                                    placeholder: _ctx.translations[_ctx.currentLanguage].Search,
                                    ref_for: true,
                                    ref: el => { if (el) _ctx.productRefs[category.id] = el },
                                    "onUpdate:modelValue": option => _ctx.handleSelected(option, _ctx.getNewItemByCategory(category.id), 'product', false)
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" >")
                                    ]),
                                    _: 2
                                  }, 1032, ["options", "label", "placeholder", "onUpdate:modelValue"])
                                ])),
                            _createElementVNode("td", _hoisted_18, [
                              _createVNode(_component_ion_input, {
                                readonly: "true",
                                modelValue: _ctx.getNewItemByCategory(category.id).product_type_name,
                                "onUpdate:modelValue": ($event: any) => ((_ctx.getNewItemByCategory(category.id).product_type_name) = $event),
                                class: "ion-text-center readonly"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _createElementVNode("td", _hoisted_19, [
                              _createVNode(_component_ion_input, {
                                type: "number",
                                min: "0",
                                max: "100",
                                modelValue: _ctx.getNewItemByCategory(category.id).area_treated,
                                "onUpdate:modelValue": ($event: any) => ((_ctx.getNewItemByCategory(category.id).area_treated) = $event),
                                modelModifiers: { number: true },
                                onIonInput: ($event: any) => (_ctx.calculateDoseProHa(_ctx.getNewItemByCategory(category.id))),
                                class: "ion-text-center"
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onIonInput"])
                            ]),
                            _createElementVNode("td", _hoisted_20, [
                              _createElementVNode("div", _hoisted_21, [
                                _createVNode(_component_ion_input, {
                                  type: "number",
                                  min: "0",
                                  step: "any",
                                  modelValue: _ctx.getNewItemByCategory(category.id).dose_pro_spread_ha,
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.getNewItemByCategory(category.id).dose_pro_spread_ha) = $event),
                                  onIonInput: ($event: any) => (_ctx.calculateDoseProHa(_ctx.getNewItemByCategory(category.id))),
                                  class: "ion-text-center"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onIonInput"]),
                                _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.getNewItemByCategory(category.id).unit.replace('/ha', '').toUpperCase()), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_22, [
                              _createElementVNode("div", _hoisted_23, [
                                _createVNode(_component_ion_input, {
                                  type: "number",
                                  min: "0",
                                  modelValue: _ctx.getNewItemByCategory(category.id).cost,
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.getNewItemByCategory(category.id).cost) = $event),
                                  modelModifiers: { number: true },
                                  class: "ion-text-center",
                                  onIonInput: ($event: any) => (_ctx.updateProductData(_ctx.getNewItemByCategory(category.id)))
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onIonInput"]),
                                _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('UnitEuro')) + " / " + _toDisplayString(_ctx.getNewItemByCategory(category.id).unit.replace('/ha', '').toUpperCase()), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_24, [
                              _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.getNewItemByCategory(category.id).total_quantity) + " " + _toDisplayString(_ctx.getNewItemByCategory(category.id).unit.replace('/ha', '').toUpperCase()), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_25, [
                                _createVNode(_component_ion_input, {
                                  type: "number",
                                  min: "0",
                                  modelValue: _ctx.getNewItemByCategory(category.id).cost_pro_ha,
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.getNewItemByCategory(category.id).cost_pro_ha) = $event),
                                  modelModifiers: { number: true },
                                  readonly: "true",
                                  class: "ion-text-center readonly"
                                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('UnitEuroProHa')), 1)
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_26, [
                              _createVNode(_component_ion_input, {
                                type: "number",
                                min: "0",
                                modelValue: _ctx.getNewItemByCategory(category.id).ift,
                                "onUpdate:modelValue": ($event: any) => ((_ctx.getNewItemByCategory(category.id).ift) = $event),
                                modelModifiers: { number: true },
                                readonly: "true",
                                class: "ion-text-center readonly"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _createElementVNode("td", null, [
                              _createVNode(_component_ion_button, {
                                onClick: ($event: any) => (_ctx.addTreatmentItem(_ctx.getNewItemByCategory(category.id)))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, { icon: _ctx.addCircleOutline }, null, 8, ["icon"])
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                (_ctx.errorMessage && _ctx.selectedCategory == category.id)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      ref_for: true,
                      ref: el => _ctx.errorContainers[category.id] = el,
                      class: "ion-margin"
                    }, [
                      _createVNode(_component_ion_text, { color: "danger" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.errorMessage), 1)
                        ]),
                        _: 1
                      })
                    ], 512))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cropTreatment.treatment_passes, (pass, index_pass) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index_pass,
                class: "ion-margin-vertical"
              }, [
                _createVNode(_component_ion_toolbar, { class: "ion-margin-vertical" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_component_ion_text, { class: "ion-padding-horizontal pass-title" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('TreatmentPass')) + " " + _toDisplayString(index_pass + 1), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _createVNode(_component_ion_select, {
                      label: _ctx.translations[_ctx.currentLanguage].PlantState,
                      justify: "start",
                      placeholder: _ctx.translations[_ctx.currentLanguage].PlantStatePlaceHolder,
                      modelValue: pass.plant_state,
                      "onUpdate:modelValue": ($event: any) => ((pass.plant_state) = $event),
                      "cancel-text": _ctx.translations[_ctx.currentLanguage].Cancel,
                      "ok-text": _ctx.translations[_ctx.currentLanguage].Choose,
                      onIonChange: ($event: any) => (_ctx.updateTreatmentPass(pass))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.plantStates, (plant_state, index_plant_state) => {
                          return (_openBlock(), _createBlock(_component_ion_select_option, {
                            key: index_plant_state,
                            value: plant_state.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(plant_state.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["label", "placeholder", "modelValue", "onUpdate:modelValue", "cancel-text", "ok-text", "onIonChange"]),
                    _createElementVNode("div", _hoisted_28, [
                      _createVNode(_component_ion_button, {
                        onClick: ($event: any) => (_ctx.setOpen(true, pass.id)),
                        color: "danger"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { icon: _ctx.trashOutline }, null, 8, ["icon"])
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ])
                  ]),
                  _: 2
                }, 1024),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("table", null, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('Product')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('ProductType')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('AreaTreated')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('DoseProSpreadHa')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('Cost')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('TotalQuantity')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('CostProHaTotalArea')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('IFTProHaTotalArea')), 1),
                      _hoisted_30
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getPassTreatments(pass.id), (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", null, [
                            _createVNode(_component_auto_fill_select, {
                              options: _ctx.products,
                              searchField: "product_name",
                              label: _ctx.translations[_ctx.currentLanguage].Product,
                              placeholder: _ctx.translations[_ctx.currentLanguage].Search,
                              selected: item.product_name,
                              "onUpdate:modelValue": option => _ctx.handleSelected(option, item, 'product', true)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" >")
                              ]),
                              _: 2
                            }, 1032, ["options", "label", "placeholder", "selected", "onUpdate:modelValue"])
                          ]),
                          _createElementVNode("td", _hoisted_31, [
                            _createVNode(_component_ion_input, {
                              readonly: "true",
                              modelValue: item.product_type_name,
                              "onUpdate:modelValue": ($event: any) => ((item.product_type_name) = $event),
                              class: "ion-text-center readonly"
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _createElementVNode("td", _hoisted_32, [
                            _createVNode(_component_ion_input, {
                              type: "number",
                              min: "0",
                              max: "100",
                              modelValue: item.area_treated,
                              "onUpdate:modelValue": ($event: any) => ((item.area_treated) = $event),
                              modelModifiers: { number: true },
                              onIonInput: ($event: any) => (_ctx.calculateDoseProHa(item)),
                              class: "ion-text-center"
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onIonInput"])
                          ]),
                          _createElementVNode("td", _hoisted_33, [
                            _createElementVNode("div", _hoisted_34, [
                              _createVNode(_component_ion_input, {
                                type: "number",
                                min: "0",
                                step: "any",
                                modelValue: item.dose_pro_spread_ha,
                                "onUpdate:modelValue": ($event: any) => ((item.dose_pro_spread_ha) = $event),
                                onIonInput: ($event: any) => (_ctx.calculateDoseProHa(item)),
                                class: "ion-text-center"
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onIonInput"]),
                              _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.unit.replace('/ha', '').toUpperCase()), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_35, [
                            _createElementVNode("div", _hoisted_36, [
                              _createVNode(_component_ion_input, {
                                type: "number",
                                min: "0",
                                modelValue: item.cost,
                                "onUpdate:modelValue": ($event: any) => ((item.cost) = $event),
                                modelModifiers: { number: true },
                                onIonInput: ($event: any) => (_ctx.handleDebouncedupdate($event, item)),
                                class: "ion-text-center"
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onIonInput"]),
                              _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('UnitEuro')) + " / " + _toDisplayString(item.unit.replace('/ha', '').toUpperCase()), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_37, [
                            _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.total_quantity) + " " + _toDisplayString(item.unit.replace('/ha', '').toUpperCase()), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_38, [
                              _createVNode(_component_ion_input, {
                                type: "number",
                                min: "0",
                                modelValue: item.cost_pro_ha,
                                "onUpdate:modelValue": ($event: any) => ((item.cost_pro_ha) = $event),
                                modelModifiers: { number: true },
                                onIonInput: ($event: any) => (_ctx.handleDebouncedupdate($event, item)),
                                class: "ion-text-center readonly"
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onIonInput"]),
                              _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('UnitEuroProHa')), 1)
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_39, [
                            _createVNode(_component_ion_input, {
                              type: "number",
                              min: "0",
                              modelValue: item.ift,
                              "onUpdate:modelValue": ($event: any) => ((item.ift) = $event),
                              modelModifiers: { number: true },
                              readonly: "true",
                              class: "ion-text-center readonly"
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(_component_ion_button, {
                              onClick: ($event: any) => (_ctx.deleteTreatmentItem(item.id)),
                              color: "danger"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, { icon: _ctx.trashOutline }, null, 8, ["icon"])
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ])
                        ]))
                      }), 128)),
                      (_ctx.getNewItemByPass(pass.id))
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_40, [
                            _createElementVNode("td", null, [
                              _createVNode(_component_auto_fill_select, {
                                options: _ctx.products,
                                searchField: "product_name",
                                label: _ctx.translations[_ctx.currentLanguage].Product,
                                placeholder: _ctx.translations[_ctx.currentLanguage].Search,
                                ref_for: true,
                                ref: el => { if (el) _ctx.productRefs[pass.id] = el },
                                "onUpdate:modelValue": option => _ctx.handleSelected(option, _ctx.getNewItemByPass(pass.id), 'product', false)
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" >")
                                ]),
                                _: 2
                              }, 1032, ["options", "label", "placeholder", "onUpdate:modelValue"])
                            ]),
                            _createElementVNode("td", _hoisted_41, [
                              _createVNode(_component_ion_input, {
                                readonly: "true",
                                modelValue: _ctx.getNewItemByPass(pass.id).product_type_name,
                                "onUpdate:modelValue": ($event: any) => ((_ctx.getNewItemByPass(pass.id).product_type_name) = $event),
                                class: "ion-text-center readonly"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _createElementVNode("td", _hoisted_42, [
                              _createVNode(_component_ion_input, {
                                type: "number",
                                min: "0",
                                max: "100",
                                modelValue: _ctx.getNewItemByPass(pass.id).area_treated,
                                "onUpdate:modelValue": ($event: any) => ((_ctx.getNewItemByPass(pass.id).area_treated) = $event),
                                modelModifiers: { number: true },
                                onIonInput: ($event: any) => (_ctx.calculateDoseProHa(_ctx.getNewItemByPass(pass.id))),
                                class: "ion-text-center"
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onIonInput"])
                            ]),
                            _createElementVNode("td", _hoisted_43, [
                              _createElementVNode("div", _hoisted_44, [
                                _createVNode(_component_ion_input, {
                                  type: "number",
                                  min: "0",
                                  step: "any",
                                  modelValue: _ctx.getNewItemByPass(pass.id).dose_pro_spread_ha,
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.getNewItemByPass(pass.id).dose_pro_spread_ha) = $event),
                                  onIonInput: ($event: any) => (_ctx.calculateDoseProHa(_ctx.getNewItemByPass(pass.id))),
                                  class: "ion-text-center"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onIonInput"]),
                                _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.getNewItemByPass(pass.id).unit.replace('/ha', '').toUpperCase()), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_45, [
                              _createElementVNode("div", _hoisted_46, [
                                _createVNode(_component_ion_input, {
                                  type: "number",
                                  min: "0",
                                  modelValue: _ctx.getNewItemByPass(pass.id).cost,
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.getNewItemByPass(pass.id).cost) = $event),
                                  modelModifiers: { number: true },
                                  class: "ion-text-center",
                                  onIonInput: ($event: any) => (_ctx.updateProductData(_ctx.getNewItemByPass(pass.id)))
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onIonInput"]),
                                _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('UnitEuro')) + " / " + _toDisplayString(_ctx.getNewItemByPass(pass.id).unit.replace('/ha', '').toUpperCase()), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_47, [
                              _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.getNewItemByPass(pass.id).total_quantity) + " " + _toDisplayString(_ctx.getNewItemByPass(pass.id).unit.replace('/ha', '').toUpperCase()), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_48, [
                                _createVNode(_component_ion_input, {
                                  type: "number",
                                  min: "0",
                                  modelValue: _ctx.getNewItemByPass(pass.id).cost_pro_ha,
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.getNewItemByPass(pass.id).cost_pro_ha) = $event),
                                  modelModifiers: { number: true },
                                  readonly: "true",
                                  class: "ion-text-center readonly"
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ])
                            ]),
                            _createElementVNode("td", null, [
                              _createVNode(_component_ion_input, {
                                type: "number",
                                min: "0",
                                modelValue: _ctx.getNewItemByPass(pass.id).ift,
                                "onUpdate:modelValue": ($event: any) => ((_ctx.getNewItemByPass(pass.id).ift) = $event),
                                modelModifiers: { number: true },
                                readonly: "true",
                                class: "ion-text-center readonly"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _createElementVNode("td", null, [
                              _createVNode(_component_ion_button, {
                                onClick: ($event: any) => (_ctx.addTreatmentItem(_ctx.getNewItemByPass(pass.id)))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, { icon: _ctx.addCircleOutline }, null, 8, ["icon"])
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                (_ctx.errorMessage && _ctx.selectedPass == pass.id)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      ref_for: true,
                      ref: el => _ctx.errorContainers[pass.id] = el,
                      class: "ion-margin"
                    }, [
                      _createVNode(_component_ion_text, { color: "danger" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.errorMessage), 1)
                        ]),
                        _: 1
                      })
                    ], 512))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            _createElementVNode("div", _hoisted_49, [
              _createVNode(_component_ion_button, { onClick: _ctx.addNewPass }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_icon, { icon: _ctx.addCircleOutline }, null, 8, ["icon"]),
                  _createTextVNode(_toDisplayString(_ctx.$t('AddNewPass')), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _createElementVNode("div", _hoisted_50, [
            _createVNode(_component_ion_grid, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_row, { class: "ion-justify-content-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, {
                      size: "auto",
                      class: "flex-container"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_51, [
                          _createElementVNode("div", _hoisted_52, [
                            _createElementVNode("table", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("td", null, _toDisplayString(_ctx.$t('IFTHerbicide')), 1),
                                _createElementVNode("td", _hoisted_53, _toDisplayString(_ctx.cropTreatment.ift_herbicide), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.$t('IFTExcludingHerbicide')), 1),
                                _createElementVNode("td", _hoisted_54, _toDisplayString(_ctx.cropTreatment.ift_excluding_herbicide), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.$t('IFTGlyphosate')), 1),
                                _createElementVNode("td", _hoisted_55, _toDisplayString(_ctx.cropTreatment.ift_glyphosate), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.$t('IFTTotal')), 1),
                                _createElementVNode("td", _hoisted_56, _toDisplayString(_ctx.cropTreatment.ift_total), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _createElementVNode("td", null, _toDisplayString(_ctx.$t('CostHerbicide')), 1),
                                _createElementVNode("td", _hoisted_57, _toDisplayString(_ctx.cropTreatment.cost_herbicide_pro_ha) + " " + _toDisplayString(_ctx.$t('UnitEuroProHa')), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.$t('CostExcludingHerbicide')), 1),
                                _createElementVNode("td", _hoisted_58, _toDisplayString(_ctx.cropTreatment.cost_excluding_herbicide_pro_ha) + " " + _toDisplayString(_ctx.$t('UnitEuroProHa')), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.$t('CostGlyphosate')), 1),
                                _createElementVNode("td", _hoisted_59, _toDisplayString(_ctx.cropTreatment.cost_glyphosate_pro_ha) + " " + _toDisplayString(_ctx.$t('UnitEuroProHa')), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.$t('TotalCost')), 1),
                                _createElementVNode("td", _hoisted_60, _toDisplayString(_ctx.cropTreatment.cost_pro_ha) + " " + _toDisplayString(_ctx.$t('UnitEuroProHa')), 1)
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_ion_alert, {
            "is-open": _ctx.showDeletePassConfirmation,
            header: _ctx.translations[_ctx.currentLanguage].DeletePassTitle,
            message: _ctx.translations[_ctx.currentLanguage].DeletePassMessage,
            buttons: _ctx.alertButtons,
            onDidDismiss: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setOpen(false, 0)))
          }, null, 8, ["is-open", "header", "message", "buttons"]),
          _createElementVNode("div", _hoisted_61, [
            _createVNode(_component_ion_button, {
              color: "secondary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.previousStep($event, _ctx.cropSeed)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Previous')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_ion_button, {
              color: "primary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.nextStep($event, _ctx.cropSeed)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Next')), 1)
              ]),
              _: 1
            })
          ])
        ]))
  ]))
}